import React, { useState, useEffect } from 'react';
import FeedbackService from './FeedbackService';
import Alert from 'react-bootstrap/Alert';
import AdvanceList from '../common/AdvanceList';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import IconButton from 'components/common/IconButton';

const FeedbackList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();
  console.log(error);
  useEffect(() => {
    const fetchData = async () => {
      const fieldsForList = [
        {
          accessor: 'employee',
          Header: 'Employee',
          headerProps: { className: 'pe-1' },
          cellProps: {
            className: 'py-2'
          },
          Cell: rowData => {
            const { employee, employeeAvatar, identifier } =
              rowData.row.original;
            const link =
              '/app/performance/feedback-form/' + identifier + '/edit';
            return (
              <Link to={link}>
                <Flex alignItems="center">
                  {employeeAvatar ? (
                    <Avatar src={employeeAvatar} size="xl" className="me-3" />
                  ) : (
                    <Avatar size="xl" name={employeeAvatar} className="me-3" />
                  )}
                  <div className="flex-1">
                    <h5 className="mb-0 fs--1">{employee}</h5>
                  </div>
                </Flex>
              </Link>
            );
          }
        },
        { accessor: 'reviewer', Header: 'Reviewer' },
        { accessor: 'dueDate', Header: 'Due Date' },
        { accessor: 'sentimentScore', Header: 'Sentiment Score' },
        { accessor: 'status', Header: 'Status' }
      ];
      console.log('Status:', fieldsForList);
      setColumns(fieldsForList);

      FeedbackService.retrieveAllFeedbackByAccount()
        .then(data => {
          console.log('Feedbacks', data);
          const updatedData = data.map(item => ({
            ...item,
            employee: item.employee.firstName + ' ' + item.employee.lastName,
            reviewer: item.reviewer.firstName + ' ' + item.reviewer.lastName,
            employeeAvatar: item.reviewer.avatar
          }));
          console.log('Feedbacks', updatedData);
          setData(updatedData);

          setNoDataToShow(!updatedData.length > 0);
        })
        .catch(error => setError({ error: error.message }));
    };
    fetchData();
  }, [noDataToShow]);

  return (
    <>
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not feedback requests to show.
          <Button
            className="btn btn-sm m-2"
            onClick={() => {
              navigate('/app/performance/feedback-request-form');
            }}
          >
            New feedback request
          </Button>
        </Alert>
      )}
      {data && !noDataToShow && (
        <>
          <IconButton
            icon={'plus'}
            variant={'success'}
            className="btn btn-sm"
            onClick={() => {
              alert(1);
              navigate('/app/performance/feedback-request-form');
            }}
          >
            New feedback request
          </IconButton>

          <AdvanceList
            columns={columns}
            data={data}
            background={true}
            newObject={{
              title: 'Request a Fededback',
              url: '/app/performance/feedback-request-form'
            }}
          />
        </>
      )}
    </>
  );
};

export default FeedbackList;
